import React from 'react';
import SearchableDropdown, { DropdownItem } from './SearchableDropdown';

interface Opponent extends DropdownItem {
  _id: string;
  name: string;
}

interface SearchableOpponentDropdownProps {
  opponents: Opponent[];
  value: string;
  onChange: (opponentId: string, opponentName?: string) => void;
  onAddNewOpponent?: (name: string) => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
}

const SearchableOpponentDropdown: React.FC<SearchableOpponentDropdownProps> = ({
  opponents,
  value,
  onChange,
  onAddNewOpponent,
  error,
  disabled = false,
  placeholder = 'Search or select opponent...',
}) => {
  return (
    <SearchableDropdown
      items={opponents}
      value={value}
      onChange={onChange}
      onAddNewItem={onAddNewOpponent}
      error={error}
      disabled={disabled}
      placeholder={placeholder}
      allowAddNew={!!onAddNewOpponent}
      addNewLabel="Add"
      noItemsMessage="No opponents available"
      searchProperty="name"
      displayProperty="name"
    />
  );
};

export default SearchableOpponentDropdown;
